import {Injectable} from '@angular/core';
import {
  IAiJobsRepository,
  AiJobDetails,
  EAiJobStatus,
} from '../../domain/content-control/ai-jobs';
import {HttpService} from '../http/http';

@Injectable()
export class AiJobsRepository implements IAiJobsRepository {
  constructor(private _httpService: HttpService) {
  }
    async get(): Promise<AiJobDetails[]> {
        const response = await this._httpService.get(`AiJobs/Get`)
        console.log('AiJobsRepository->get()', response);
        return this._toAiJobs(response);
    }

    private _toAiJobs(resultRawJson: any): AiJobDetails[] {
      if (resultRawJson && resultRawJson.length > 0) {
        return resultRawJson.map(aiJobResponse => new AiJobDetails(aiJobResponse.Uid, aiJobResponse.AvailabilityZoneId, aiJobResponse.LastStatus, aiJobResponse.ContentControlItemUid))
      } else {
        return [];
      }
    }
}
